import { EServices } from './../types/tableHelper'
import { CurrencyData, CurrencyModel } from './../types/currency/currency'
import Extensions from './extensions'

export default class Currency {
	public Current: string
	private readonly _def: string

	constructor(def: string = 'USD') {
		this.SetCurrency((this._def = def))
	}

	public CurrencySet(): Map<string, CurrencyModel> {
		return CurrencyData.AllCurrencies
	}

	public Codes(): IterableIterator<string> {
		return this.CurrencySet().keys()
	}

	public SetCurrency(currency: string): CurrencyModel {
		if (currency == null || !this.CheckForExists(currency)) return null

		this.Current = currency

		return this.CurrencySet().get(this.Current)
	}

	public GetCurrencyText(price: number, sourceCurrency: string = null): string {
		sourceCurrency ??= this._def

		var value = this.Calculate(price, sourceCurrency)

		return this.GetSymbol(value)
	}

	public GetCurrencyTextByService(Price: number, service: EServices): string {
		return this.GetCurrencyText(Price, CurrencyData.GetCurrency(service))
	}

	public GetSymbol(price: number, currencyStr: string = null): string {
		var currency = this.CurrencySet().get(currencyStr ?? this.Current)

		if (currency == null) return '—'

		// Курс валюты приходит вместе с пользователем. Пока он не пришёл (или у площадки
		// исходная валюта без курса), Calculate даёт NaN и в цене выводилось «$ NaN».
		// Показываем прочерк: цены нет, а не цена сломана.
		if (!isFinite(price)) return '—'

		// Цена всегда с копейками: раньше «$ 10.7» и «$ 1.1» соседствовали с «$ 10.75»
		const text = price.toFixed(2)

		return currency.IsLeft ? `${currency.Symbol} ${text}` : `${text} ${currency.Symbol}`
	}

	public GetPrice(Price: number, sourceCurrency: string): number {
		return this.Calculate(Price, sourceCurrency)
	}

	public GetPriceByService(Price: number, service: EServices) {
		return this.GetPrice(Price, CurrencyData.GetCurrency(service))
	}

	private Calculate(Price: number, sourceCurrency: string): number {
		if (sourceCurrency === this.Current) return Price

		return Extensions.Ceil((Price / this.CurrencySet().get(sourceCurrency).Value) * this.CurrencySet().get(this.Current).Value)
	}

	private CheckForExists(currency: string): boolean {
		return this.CurrencySet().has(currency)
	}

	public GetClone(): Currency {
		return structuredClone(this)
	}
}
